module.exports = __webpack_public_path__ + "media/images/old/playcanvas-logo-7f202a6b9758d3e25d3c7545806c4a91.png";